import { render, staticRenderFns } from "./UsuarioFuncionarioList.vue?vue&type=template&id=4ad15322&lang=html"
import script from "./UsuarioFuncionarioList.vue?vue&type=script&lang=js"
export * from "./UsuarioFuncionarioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports